module.exports = __webpack_public_path__ + "img/Karolina Machowska.06f0e8b9.webp";